import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../../../core/services/store/shared-store/shared-storage.service';

@Component({
    selector: 'app-flow-deletion-success',
    templateUrl: './flow-deletion-success.component.html',
    styleUrls: ['./flow-deletion-success.component.scss']
})
export class FlowDeletionSuccessComponent implements OnInit, OnDestroy {
  private paramsSub: Subscription;
  public flowName: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.paramsSub = this.route.params.subscribe((params) => {
      this.flowName = params['flowName'];
    });
  }

  ngOnDestroy() {
    this.paramsSub.unsubscribe();
  }

  toNewFlow() {
    this.router.navigate([
      'flow',
      this.sharedService.getEnvironment(),
      this.sharedService.getEntityType(),
      this.sharedService.getEntityId(),
      this.sharedService.getNewFlowName(),
    ]);
  }
}
